import { Pipe, PipeTransform } from '@angular/core';
import { SchoolYear } from '../models/schoolyear.model';

// Pipe
@Pipe({
  name: 'schoolYear',
  standalone: true,
})
export class SchoolYearPipe implements PipeTransform {
  transform(year: SchoolYear | string | undefined): string | null {
    if (!year) return null;

    // If year is a string (e.g., "2025")
    if (typeof year === 'string') {
      const startYear = parseInt(year);
      if (!isNaN(startYear)) {
        return `${startYear}/${startYear + 1}`;
      }
      return year; // Return original string if not a valid number
    }

    // If year is a SchoolYear object
    if (year.isCustomDate) {
      return year.startDate.toDate().toLocaleDateString();
    }
    const startYear = year.startDate.toDate().getFullYear();
    return `${startYear}/${startYear + 1}`;
  }
}
